import { render, staticRenderFns } from "./OpTextField.vue?vue&type=template&id=3a0f513d&scoped=true&"
import script from "./OpTextField.vue?vue&type=script&lang=js&"
export * from "./OpTextField.vue?vue&type=script&lang=js&"
import style0 from "./OpTextField.vue?vue&type=style&index=0&id=3a0f513d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0f513d",
  null
  
)

export default component.exports